const apiUrl = process.env.NEXT_PUBLIC_SMARTFORM_API_URL;
const apiKey = process.env.NEXT_PUBLIC_SMARTFORM_API_KEY;
const clientId = process.env.NEXT_PUBLIC_SMARTFORM_API_CLIENT_ID;

export enum SmartFormFieldTypes {
  StreetAndNumber = 'STREET_AND_NUMBER',
  City = 'CITY',
  Zip = 'ZIP',
}

export enum SmartFormCountry {
  CZ = 'CZ',
  SK = 'SK',
}

interface AddressOracleRequestDto {
  id: number;
  fieldType: SmartFormFieldTypes;
  values: {
    [SmartFormFieldTypes.StreetAndNumber]?: string;
    [SmartFormFieldTypes.City]?: string;
    [SmartFormFieldTypes.Zip]?: string;
  };
  country: SmartFormCountry;
  limit: number;
}

export interface SmartFormAddressSuggestion {
  fieldType: SmartFormFieldTypes;
  values: {
    NUMBER: string;
    STREET_AND_NUMBER: string;
    STREET: string;
    CITY_EXTENDED: string;
    CITY: string;
    DISTRICT: string;
    REGION: string;
    ZIP: string;
    POST: string;
    WHOLE_ADDRESS: string;
  };
  flags: {
    WHOLE_ADDRESS: 'true' | 'false';
  };
}

interface AddressOracleResponse {
  resultCode: string;
  errorMessage: string | null;
  id: number;
  suggestions: SmartFormAddressSuggestion[];
}

export const getAddressSuggestions = async (requestDto: AddressOracleRequestDto) => {
  try {
    if (!apiUrl) {
      throw new Error('No API URL provided for Smartform');
    }

    if (!apiKey) {
      throw new Error('No API key provided for Smartform');
    }

    if (!clientId) {
      throw new Error('No Client ID provided for Smartform');
    }

    const response = await fetch(`${window.location.origin}/smartform/oracleAddress/v11`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'User-Agent': 'Next.js Proxy',
        Authorization: `Basic ${btoa(`${clientId}:${apiKey}`)}`,
      },
      body: JSON.stringify(requestDto),
    });

    return response.json() as Promise<AddressOracleResponse>;
  } catch (error: unknown) {
    throw error;
  }
};
